// Client for POST /api/outlook/finalize.
// Called after a Casey-drafted reply has been inserted into the Outlook
// reply window. Backend ensures the case-folder exists in the org's
// shared mailbox and moves the source email there.

import { apiRequest } from "./api";

export interface FinalizeRequest {
  caseId: string;
  /** Graph immutable ID of the email that was replied to. */
  sourceMessageId: string;
  /** UPN of the mailbox where source lives — defaults server-side to the
   *  signed-in user's email. Pass explicitly only when archiving on
   *  behalf of someone else (delegated mailbox). */
  sourceUserUpn?: string;
  /** When the add-in knows the just-sent reply's Graph ID. Optional. */
  sentMessageId?: string;
}

export interface FinalizeResponse {
  moved: boolean;
  folderId?: string;
  newMessageId?: string;
  warning?: string;
  linkedSentMessage?: boolean;
}

export function finalize(req: FinalizeRequest, signal?: AbortSignal): Promise<FinalizeResponse> {
  return apiRequest<FinalizeResponse>("/api/outlook/finalize", {
    method: "POST",
    body: req,
    signal,
  });
}
